import React from 'react';
import ActionButtons from './ActionButtons';
import PropertyDetailsCard from './PropertyDetailsCard';
import ValuationCard from './ValuationCard';
import PropertyCharacteristics from './PropertyCharacteristics';
import HistoricalChart from './HistoricalChart';
import ComparableProperties from './ComparableProperties';
import AgentInfo from './AgentInfo';

const ExpandedRowContent = ({ 
  listing, 
  propertyData, 
  onAddressClick,
  onZillowClick,
  onSummaryClick,
  onPropertyDetailsClick,
  onResidentDetailsClick,
  isProUser,
  onSubscriptionModal
}) => {
  return (
    <div className="text-sm max-w-full overflow-x-hidden">
      {/* Action buttons - moved to top */}
      <ActionButtons
        listing={listing}
        onAddressClick={onAddressClick}
        onZillowClick={onZillowClick}
        onSummaryClick={onSummaryClick}
        onPropertyDetailsClick={onPropertyDetailsClick}
        onResidentDetailsClick={onResidentDetailsClick}
        isProUser={isProUser}
        onSubscriptionModal={onSubscriptionModal}
      />

      {/* Property details - Enhanced with card design */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6 w-full">
        {/* Property Details Card */}
        <PropertyDetailsCard 
          listing={listing} 
          onPropertyDetailsClick={onPropertyDetailsClick}
          isProUser={isProUser}
          onSubscriptionModal={onSubscriptionModal}
        />
        
        {/* Valuation Details Card */}
        <ValuationCard 
          listing={listing} 
          propertyData={propertyData}
          isProUser={isProUser}
          onSubscriptionModal={onSubscriptionModal}
        />
      </div>
      
      {/* Property Characteristics Card - Full Width - Only for Pro users */}
      {isProUser && <PropertyCharacteristics propertyData={propertyData} />}
      
      {/* Historical Zestimate & Comparable Properties - Enhanced styling - Only for Pro users */}
      {isProUser && propertyData && propertyData.status === 'success' && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Historical Zestimate Chart Card */}
          <HistoricalChart propertyData={propertyData} />
          
          {/* Comparable Properties Card */}
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow">
            <div className="p-5">
              <div className="flex items-center mb-4">
                <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-3">
                  <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <h4 className="text-lg font-semibold text-gray-900">Comparable Properties</h4>
              </div>
              <ComparableProperties propertyData={propertyData} listing={listing} />
            </div>
          </div>
        </div>
      )}
      
      {/* Add Agent/Broker Information Section - Only for Pro users */}
      {isProUser && <AgentInfo propertyData={propertyData} />}
    </div>
  );
};

export default ExpandedRowContent;